import React, { useContext, createContext, useMemo, useCallback } from 'react';
import { useGetOrderItemStatuses } from '../core/hooks/orderHooks';

export const OrderItemStatusContext = createContext({
  isLoading: true,
  statuses: {},
  getName() {},
});

export function useOrderItemStatus() {
  const context = useContext(OrderItemStatusContext);
  if (!context) {
    throw new Error('Please use hook inside of OrderItemStatusProvider.');
  }

  return context;
}

export function OrderItemStatusProvider({ children }) {
  const { data, isLoading } = useGetOrderItemStatuses();

  const statuses = useMemo(() => {
    if (!data?.orderItemStatuses) {
      return {};
    }

    return data.orderItemStatuses.reduce(
      (acc, status) => ({
        ...acc,
        [status.key]: {
          name: status.name,
          isImmutable: status.isImmutable,
        },
      }),
      {}
    );
  }, [data?.orderItemStatuses]);

  const getName = useCallback(
    (status, locale) => statuses[status]?.name?.[locale] || status,
    [isLoading, statuses]
  );

  return (
    <OrderItemStatusContext.Provider
      value={{
        statuses: statuses,
        isLoading: isLoading,
        getName: getName,
      }}
    >
      {children}
    </OrderItemStatusContext.Provider>
  );
}
